import { render, staticRenderFns } from "./insufficientFEDetected.vue?vue&type=template&id=639dd67b&"
import script from "./insufficientFEDetected.vue?vue&type=script&lang=js&"
export * from "./insufficientFEDetected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports